export enum Language {
  English = 'en',
  Spanish = 'es',
}
